export enum CardLinkingFidelCountries {
  GBR = 'GBR',
  IRL = 'IRL',
  USA = 'USA',
  SWE = 'SWE',
}
